import React from 'react';
import { useProductDetail } from './presenter';
import { ProductDetailView } from './view';
import { Route } from '../../../components/layout/ProtectedLayout';

type Props = {
  id: string;
  navigate: (r: Route) => void;
};

const ProductViewPage: React.FC<Props> = ({ id, navigate }) => {
  const vm = useProductDetail(id);
  return (
    <ProductDetailView
      data={vm.data}
      loading={vm.loading}
      error={vm.error}
      onBack={() => navigate({ name: 'products/index' })}
      onEdit={id => navigate({ name: 'products/update', params: { id: String(id) } })}
    />
  );
};

export default ProductViewPage;
